export default "__VITE_ASSET__DeIeMvVS__"